(function () {
  'use strict';
  if (window.kpPick) return;
  window.kpPick = {};

  const products = new Map();
  const approved = new WeakSet();
  const pending = new WeakSet();
  const skipOffers = new WeakSet();
  let dialog;
  let active;

  function candidate(form) {
    if (!(form instanceof HTMLFormElement) ||
        !form.action.includes('/cart/add') || !form.querySelector('input[name="id"]') ||
        form.querySelector('select, input[type="radio"]') ||
        /^product-form-template--.*__main$/.test(form.id) ||
        form.closest('product-form[data-section-id$="__main"], quick-add-modal')) return null;
    let node = form;
    for (let depth = 0; node && depth <= 8; depth++, node = node.parentElement) {
      const link = node.querySelector('a[href*="/products/"]');
      if (link) {
        const match = new URL(link.href, location.href).pathname.match(/\/products\/([^/]+)/);
        return match ? match[1] : null;
      }
    }
    return null;
  }

  function product(handle) {
    if (!products.has(handle)) {
      const entry = { data: null, promise: null };
      entry.promise = Promise.resolve().then(() => fetch('/products/' + handle + '.js'))
        .then((response) => {
          if (!response.ok) throw new Error('Product request failed');
          return response.json();
        }).then((data) => {
          if (!Array.isArray(data.variants) || !Array.isArray(data.options)) {
            throw new Error('Invalid product data');
          }
          entry.data = data;
          return data;
        });
      entry.promise.catch(() => { if (products.get(handle) === entry) products.delete(handle); });
      products.set(handle, entry);
    }
    return products.get(handle);
  }

  // Approval is consumed by our capture listener before the theme sees this submit.
  function resubmit(form, submitter, variant) {
    const input = form.querySelector('input[name="id"]');
    const original = input && input.value;
    try {
      if (variant && input) input.value = String(variant.id);
      approved.add(form);
      try {
        if (typeof form.requestSubmit !== 'function') throw new Error('Use click fallback');
        if (submitter) form.requestSubmit(submitter);
        else form.requestSubmit();
      } catch (error) {
        if (submitter) submitter.click();
        else HTMLFormElement.prototype.requestSubmit.call(form);
      }
    } catch (error) {
      // Last resort still dispatches through the theme, without making a cart request here.
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    } finally {
      if (input) input.value = original;
      approved.delete(form);
    }
  }

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function button(className, text) {
    const node = element('button', className, text);
    node.type = 'button';
    return node;
  }

  function dismiss() {
    const previous = active;
    active = null;
    if (dialog && dialog.open) dialog.close();
    if (previous && previous.resolve) previous.resolve(null);
    if (previous && previous.submitter && previous.submitter.isConnected) {
      previous.submitter.focus({ preventScroll: true });
    }
  }

  function mount() {
    if (dialog) return;
    const style = element('style');
    style.textContent = `
      .kp-pick { inset: auto 0 0; margin: 0; padding: 0; width: 100%; max-width: 100%;
        max-height: 86dvh; border: 0; border-radius: 3px; background: #FFFFFF; color: #0B0C0E;
        font-family: inherit; font-size: 16px; line-height: 1.4; overflow: hidden; box-sizing: border-box; }
      .kp-pick[open] { display: flex; flex-direction: column; }
      .kp-pick::backdrop { background: rgba(11,12,14,.6); }
      .kp-pick *, .kp-pick *::before, .kp-pick *::after { box-sizing: border-box; }
      .kp-pick button { appearance: none; font-family: inherit; font-size: 14px; line-height: 1.35;
        letter-spacing: normal; text-transform: none; min-width: 44px; min-height: 44px; margin: 0;
        border: 1px solid #BEAE82; border-radius: 3px; padding: 10px; background: #FFFFFF;
        color: #0B0C0E; cursor: pointer; box-shadow: none; }
      .kp-pick button:focus-visible { outline: 2px solid #0B0C0E; outline-offset: 2px; }
      .kp-pick button[aria-pressed="true"] { background: #F5EBD2; border: 2px solid #0B0C0E; padding: 9px; }
      .kp-pick button:disabled { background: #F1F1F1; color: #5C5C5C; border-color: #DFDFDF;
        cursor: not-allowed; opacity: 1; }
      .kp-pick .kp-pick__header { position: relative; flex: 0 0 auto; padding: 26px 64px 16px 16px;
        border-bottom: 1px solid #ECECEC; }
      .kp-pick .kp-pick__handle { position: absolute; top: 8px; left: calc(50% - 20px);
        width: 40px; height: 4px; border-radius: 3px; background: #BEAE82; }
      .kp-pick .kp-pick__title { margin: 0 0 4px; color: #0B0C0E; font: inherit;
        font-size: 20px; font-weight: 700; overflow-wrap: anywhere; }
      .kp-pick .kp-pick__prompt { margin: 0; color: #4A4A4A; }
      .kp-pick .kp-pick__close { position: absolute; top: 18px; right: 10px; width: 44px; height: 44px;
        border: 0; padding: 0; font-size: 26px; }
      .kp-pick .kp-pick__choices { min-height: 0; overflow-y: auto; overflow-x: hidden;
        overscroll-behavior: contain; padding: 16px; flex: 1 1 auto; }
      .kp-pick .kp-pick__tiles { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px; }
      .kp-pick .kp-pick__tile { display: flex; flex-direction: column; align-items: center;
        width: 100%; min-width: 0; gap: 6px; overflow-wrap: anywhere; }
      .kp-pick .kp-pick__tile img { display: block; width: 100%; height: auto; aspect-ratio: 1;
        object-fit: contain; max-width: 200px; }
      .kp-pick .kp-pick__sold { font-size: 12px; color: #5C5C5C; }
      .kp-pick .kp-pick__group + .kp-pick__group { margin-top: 20px; }
      .kp-pick .kp-pick__label { display: block; margin-bottom: 8px; font-weight: 700; }
      .kp-pick .kp-pick__chips { display: flex; flex-wrap: wrap; gap: 8px; }
      .kp-pick .kp-pick__footer { position: sticky; bottom: 0; flex: 0 0 auto; background: #FFFFFF;
        border-top: 1px solid #ECECEC; padding: 12px 16px; padding-bottom: calc(12px + env(safe-area-inset-bottom)); }
      .kp-pick .kp-pick__add { width: 100%; min-height: 48px; background: #E1C78F; font-weight: 700; }
      .kp-pick .kp-pick__add:disabled { background: #F1F1F1; }
      .kp-pick .kp-pick__add[aria-busy="true"] { background: #F1F1F1; color: #0B0C0E; }
      .kp-pick .kp-pick__error { margin: 0 0 8px; padding: 8px 10px; border-radius: 3px; background: #FBEAEA;
        color: #8C1D18; font-size: 14px; line-height: 1.35; overflow-wrap: anywhere; }
      .kp-pick .kp-pick__error:empty { display: none; }
      .kp-pick .kp-pick__pair { border-top: 1px solid #ECECEC; margin-top: 16px; padding-top: 16px; }
      .kp-pick .kp-pick__pair h3 { margin: 0; font: inherit; font-size: 18px; font-weight: 900; }
      .kp-pick .kp-pick__pair-copy { margin: 4px 0 12px; font-size: 14px; color: #4A4A4A; }
      .kp-pick .kp-pick__pair-options { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 8px; }
      .kp-pick .kp-pick__pair-option { text-align: left; overflow-wrap: anywhere; }
      .kp-pick .kp-pick__pair-option > span { display: block; }
      .kp-pick .kp-pick__pair-option img { display: block; width: 60px; height: 60px; object-fit: contain; margin: 0 0 8px;
        padding: 4px; background: #FFFFFF; border: 1px solid #ECECEC; border-radius: 3px; }
      .kp-pick .kp-pick__pair-label { font-weight: 700; }
      .kp-pick .kp-pick__pair-selected { display: grid; grid-template-columns: minmax(0, 1fr) auto;
        align-items: center; gap: 8px; margin-top: 12px; overflow-wrap: anywhere; }
      .kp-pick .kp-pick__bundle-save { margin: 0 0 8px; padding: 6px 10px; border-radius: 3px; background: #F5EBD2;
        color: #0B0C0E; font-size: 14px; font-weight: 700; text-align: center; }
      .kp-pick .kp-pick__pair-error { margin: 8px 0 0; font-size: 14px; color: #4A4A4A; overflow-wrap: anywhere; }
      .kp-pick .kp-pick__pair-error:empty { margin: 0; }
      .kp-pick .kp-pick__header--back { padding-right: 112px; }
      .kp-pick .kp-pick__back { position: absolute; top: 18px; right: 58px; width: 44px; height: 44px; }
      @media (min-width: 750px) {
        .kp-pick { inset: 0; margin: auto; width: calc(100% - 48px); max-width: 640px; }
        .kp-pick .kp-pick__tiles { grid-template-columns: repeat(4, minmax(0, 1fr)); }
        .kp-pick .kp-pick__handle { display: none; }
      }
      @media (prefers-reduced-motion: no-preference) {
        .kp-pick[open] { animation: kp-pick-enter 240ms ease-out; }
        @keyframes kp-pick-enter { from { opacity: 0; transform: translateY(18px); }
          to { opacity: 1; transform: translateY(0); } }
      }
    `;
    document.head.append(style);
    dialog = element('dialog', 'kp-pick');
    dialog.setAttribute('data-kp-pick', '');
    dialog.setAttribute('aria-labelledby', 'kp-pick-title');
    dialog.setAttribute('aria-describedby', 'kp-pick-prompt');
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      dismiss();
    });
    dialog.addEventListener('close', () => { if (!dialog.open) dismiss(); });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) dismiss();
    });
    document.body.append(dialog);
  }

  function openPicker(data, form, submitter, choice) {
    mount();
    if (dialog.open) dismiss();
    const selections = data.options.map(() => null);
    const names = data.options.map((option) => typeof option === 'string' ? option : option.name);
    const noun = String(names[0] || '').toLowerCase();
    const prompt = names.length > 1 ? 'Choose options'
      : ['flavor', 'color', 'colour', 'size', 'style', 'scent', 'count', 'quantity', 'strength', 'design'].includes(noun)
        ? 'Choose a ' + (noun === 'colour' ? 'color' : noun) : 'Choose an option';
    const header = element('div', 'kp-pick__header');
    const handle = element('span', 'kp-pick__handle');
    handle.setAttribute('aria-hidden', 'true');
    const title = element('h2', 'kp-pick__title', choice && choice.title || data.title);
    title.id = 'kp-pick-title';
    const instruction = element('p', 'kp-pick__prompt', choice && choice.subtitle || prompt);
    instruction.id = 'kp-pick-prompt';
    const close = button('kp-pick__close', '×');
    close.setAttribute('data-kp-pick-close', '');
    close.setAttribute('aria-label', 'Close');
    close.addEventListener('click', dismiss);
    header.append(handle, title, instruction, close);
    const choices = element('div', 'kp-pick__choices');
    const footer = element('div', 'kp-pick__footer');
    const add = button('kp-pick__add', prompt);
    add.setAttribute('data-kp-pick-add', '');
    add.disabled = true;
    // A failed add says so here, above the button, instead of doing nothing (A2-2, 2026-10-02).
    const failure = element('p', 'kp-pick__error');
    failure.setAttribute('role', 'alert');
    failure.setAttribute('data-kp-pick-add-error', '');
    footer.append(failure, add);
    let selected = choice ? data.variants.find((v) => v.available && String(v.id) === String(choice.selectedId)) : null;
    if (selected) selected.options.forEach((value, index) => { selections[index] = value; });
    const controls = [];
    let pair;
    let busy = false;
    // Choosing re-renders the pair section below the tiles. Keep the sheet where it was and the chosen tile in view,
    // so the flavors never look like they vanished (A2-2: the sheet jumped to "Make it a pair" on Eddie's iPhone).
    function choose(node, apply) {
      const top = choices.scrollTop;
      failure.textContent = '';
      apply();
      update();
      choices.scrollTop = top;
      const box = choices.getBoundingClientRect();
      const rect = node.getBoundingClientRect();
      if (rect.top < box.top) choices.scrollTop -= box.top - rect.top + 8;
      else if (rect.bottom > box.bottom) choices.scrollTop += rect.bottom - box.bottom + 8;
    }

    function update() {
      controls.forEach(({ node, index, value, variant }) => {
        const available = variant ? variant.available : data.variants.some((v) => v.available &&
          v.options[index] === value && selections.every((s, i) => i === index || s === null || s === v.options[i]));
        node.disabled = !available || busy;
        node.setAttribute('aria-disabled', String(!available || busy));
        node.setAttribute('aria-pressed', String(variant ? selected === variant : selections[index] === value));
      });
      if (names.length > 1) {
        selected = data.variants.find((v) => v.available && v.options.every((value, i) => selections[i] === value));
      }
      add.disabled = !selected || busy;
      add.textContent = choice ? 'Use this flavor'
        : selected ? 'Add to cart · $' + (selected.price / 100).toFixed(2) : prompt;
      if (pair) {
        try { if (pair.update() === false) pair = null; }
        catch (error) {
          pair.remove();
          pair = null;
          add.textContent = selected ? 'Add to cart · ' + offerMoney(selected.price) : prompt;
        }
      }
    }

    if (names.length === 1) {
      const tiles = element('div', 'kp-pick__tiles');
      data.variants.forEach((variant) => {
        const tile = button('kp-pick__tile');
        tile.setAttribute('data-kp-pick-variant', String(variant.id));
        const name = variant.options[0];
        const source = variant.featured_image || data.featured_image;
        if (source) {
          const img = element('img');
          const url = new URL(typeof source === 'string' ? source : source.src, location.href);
          url.searchParams.set('width', '200');
          img.src = url.href;
          img.alt = name;
          img.width = 200;
          img.height = 200;
          tile.append(img);
        }
        tile.append(element('span', '', name));
        if (!variant.available) tile.append(element('span', 'kp-pick__sold', 'Sold out'));
        tile.addEventListener('click', () => choose(tile, () => { selected = variant; }));
        controls.push({ node: tile, variant: variant });
        tiles.append(tile);
      });
      choices.append(tiles);
    } else {
      names.forEach((name, index) => {
        const group = element('div', 'kp-pick__group');
        group.setAttribute('data-kp-pick-group', name);
        group.setAttribute('role', 'group');
        group.setAttribute('aria-label', name);
        const chips = element('div', 'kp-pick__chips');
        const values = [...new Set(data.variants.map((variant) => variant.options[index]))];
        values.forEach((value) => {
          const chip = button('', value);
          chip.setAttribute('data-value', value);
          chip.addEventListener('click', () => choose(chip, () => {
            selections[index] = selections[index] === value ? null : value;
          }));
          controls.push({ node: chip, index: index, value: value });
          chips.append(chip);
        });
        group.append(element('span', 'kp-pick__label', name), chips);
        choices.append(group);
      });
    }
    if (!choice) {
      try { pair = pickerPair(data, choices, header, footer, add, () => selected, () => busy, update); }
      catch (error) {
        const section = choices.querySelector('[data-kp-pick-pair]');
        if (section) section.remove();
      }
    }
    update();
    add.addEventListener('click', async () => {
      if (!selected || add.disabled) return;
      add.disabled = true;
      if (choice) {
        choice.resolve(selected.id);
        dismiss();
        return;
      }
      // A2-2: the sheet adds the item itself (one request, with the pair partner when chosen) and closes only once
      // the cart has it. Handing the add back to the card's form could fail silently behind the sheet: Dawn's
      // product-form ignores a submit while its button is aria-disabled and shows its errors on the card.
      const main = selected;
      const state = active;
      const partner = pair && pair.partner();
      busy = true;
      add.setAttribute('aria-busy', 'true');
      failure.textContent = '';
      if (pair) pair.error('');
      update();
      add.textContent = 'Adding…';
      let json;
      try {
        json = await addToCart(form, main, partner);
      } catch (error) {
        busy = false;
        add.setAttribute('aria-busy', 'false');
        update();
        failure.textContent = error && error.message || "Couldn't add to cart. Try again.";
        failure.scrollIntoView({ block: 'nearest' });
        return;
      }
      if (partner) offerTrack('kp_pair_picker_add', pair.mode);
      if (active === state) dismiss();
      showCart(json, main, submitter);
    });
    dialog.replaceChildren(header, choices, footer);
    active = { form: form, submitter: submitter, resolve: choice && choice.resolve };
    dialog.showModal();
  }

  // What Dawn's product-form sends, as JSON so the pair partner rides in the same request: the form's quantity,
  // properties and selling plan with the chosen variant.
  async function addToCart(form, variant, partner) {
    const fields = form ? new FormData(form) : new FormData();
    const item = { id: variant.id, quantity: Math.max(1, parseInt(fields.get('quantity'), 10) || 1) };
    const properties = {};
    for (const [key, value] of fields.entries()) {
      const match = /^properties\[(.+)\]$/.exec(key);
      if (match && typeof value === 'string' && value !== '') properties[match[1]] = value;
    }
    if (Object.keys(properties).length) item.properties = properties;
    if (fields.get('selling_plan')) item.selling_plan = fields.get('selling_plan');
    const items = [item];
    if (partner) items.push({ id: partner.id, quantity: 1, properties: { _kp_pair: 'picker' } });
    const body = { items: items };
    const cart = document.querySelector('cart-drawer');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = location.pathname;
    }
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const timer = setTimeout(() => { if (controller) controller.abort(); }, 12000);
    let response;
    try {
      response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body), signal: controller ? controller.signal : undefined
      });
    } catch (error) {
      throw new Error(error && error.name === 'AbortError' ? 'That took too long. Check your connection and try again.'
        : "Couldn't reach the store. Check your connection and try again.");
    } finally {
      clearTimeout(timer);
    }
    const json = await response.json().catch(() => ({}));
    if (!response.ok || json.status) {
      try {
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: String(variant.id),
            errors: json.errors || json.description, message: json.message });
        }
      } catch (error) { /* reporting must not hide the message */ }
      throw new Error(json.description || json.message || (response.status === 429
        ? 'Too many tries in a row. Wait a few seconds and try again.' : "Couldn't add to cart. Try again."));
    }
    return json;
  }

  // Then what product-form does with the answer: publish cartUpdate and render the drawer (which opens it).
  function showCart(json, variant, submitter) {
    const cart = document.querySelector('cart-drawer');
    try {
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: String(variant.id), cartData: json });
      }
    } catch (error) { /* the drawer below still shows the cart */ }
    if (cart && json.sections && typeof cart.renderContents === 'function') {
      if (submitter && typeof cart.setActiveElement === 'function') cart.setActiveElement(submitter);
      cart.renderContents(json);
      cart.classList.remove('is-empty');
    } else {
      window.location.href = window.routes && window.routes.cart_url || '/cart';
    }
  }

  function pickerPair(data, choices, header, footer, add, main, busy, update) {
    const configNode = document.getElementById('kp-pair-config');
    if (!configNode) return null;
    const config = JSON.parse(configNode.textContent);
    const mode = config.tips.includes(data.handle) ? 'papers' : config.papers.includes(data.handle) ? 'tips' : null;
    if (!mode) return null;
    const discount = config.discount;
    const partners = (mode === 'papers' ? config.paperPartners : config.tipPartners).map((entry) => ({
      handle: entry.handle, label: entry.label, product: null, selected: null, explicit: false, failed: false
    }));
    if (!partners.length || !Number.isFinite(discount.amount) || !Number.isFinite(discount.minTips)) return null;
    const requests = partners.map((entry) => product(entry.handle).promise);
    const section = element('section', 'kp-pick__pair');
    section.setAttribute('data-kp-pick-pair', '');
    const save = element('p', 'kp-pick__bundle-save');
    save.setAttribute('data-kp-pick-bundle-save', '');
    save.setAttribute('aria-live', 'polite');

    function thumbnail(data, variant) {
      const img = element('img');
      const source = variant.featured_image || data.featured_image;
      if (source) {
        const url = new URL(typeof source === 'string' ? source : source.src, location.href);
        url.searchParams.set('width', '112');
        img.src = url.href;
      }
      img.width = 60;
      img.height = 60;
      img.alt = '';
      return img;
    }
    let partner = null;
    let error = '';
    let removed = false;
    const cheapest = data.variants.filter((variant) => variant.available).reduce((a, b) => !a || b.price < a.price ? b : a, null);

    function match(entry) {
      if (!entry.product || entry.explicit) return;
      entry.selected = (main() && offerMatch(entry.product, offerFlavor(data, main()))) ||
        entry.product.variants.find((variant) => variant.available &&
          offerWords(offerFlavor(entry.product, variant)).includes(mode === 'papers' ? 'natural' : 'variety')) ||
        entry.product.variants.find((variant) => variant.available);
    }

    function render() {
      if (removed) return false;
      partners.forEach(match);
      const entries = partners.filter((entry) => !entry.failed);
      if (!entries.length) { remove(); return false; }
      // Every choice rebuilds the section, so hand focus back to the same control for keyboard users.
      const focused = section.contains(document.activeElement) ? document.activeElement : null;
      const focusKey = focused && (focused.getAttribute('data-kp-pick-pair-option') ||
        (focused.hasAttribute('data-kp-pick-pair-change') ? 'change' : null));
      const tips = mode === 'papers' ? main() || cheapest : partner && partner.selected;
      const honest = !!tips && tips.price >= discount.minTips;
      const copy = mode === 'tips' ? 'Add flavor tips and save $1 on your papers.'
        : honest ? 'Add hemp papers and save $1.' : 'Add hemp papers.';
      const options = element('div', 'kp-pick__pair-options');
      options.setAttribute('role', 'group');
      options.setAttribute('aria-label', 'Pair with');
      [null].concat(entries).forEach((entry) => {
        const option = button('kp-pick__pair-option');
        option.setAttribute('data-kp-pick-pair-option', entry ? entry.handle : 'none');
        option.setAttribute('aria-pressed', String(entry === partner));
        option.disabled = busy() || !!entry && !entry.selected;
        // Eddie 2026-10-01: no cross-out on the cards, just the cost, with the partner's thumbnail. The $1 is shown
        // once, as "Bundle & save $1" by the add button, when the shopper goes with the pair.
        if (entry && entry.selected) option.append(thumbnail(entry.product, entry.selected));
        option.append(element('span', 'kp-pick__pair-label', entry ? '+ ' + entry.label
          : mode === 'papers' ? 'Just the tips' : 'Just the papers'));
        if (entry && entry.selected) option.append(element('span', '', offerMoney(entry.selected.price)));
        option.addEventListener('click', () => {
          partner = entry;
          error = '';
          update();
          // The tiles push the partner row under the sticky Add button on a phone; bring it into view.
          const row = section.querySelector('[data-kp-pick-pair-variant]');
          if (row) row.scrollIntoView({ block: 'nearest' });
        });
        options.append(option);
      });
      section.replaceChildren(element('h3', '', 'Make it a pair.'), element('p', 'kp-pick__pair-copy', copy), options);
      if (partner && partner.selected) {
        const row = element('div', 'kp-pick__pair-selected');
        row.setAttribute('data-kp-pick-pair-variant', String(partner.selected.id));
        const change = button('', 'Change flavor');
        change.setAttribute('data-kp-pick-pair-change', '');
        change.disabled = busy();
        change.addEventListener('click', () => {
          try { changeFlavor(partner); }
          catch (error) { dialog.replaceChildren(header, choices, footer); }
        });
        row.append(element('span', '', offerFlavor(partner.product, partner.selected)), change);
        section.append(row);
        if (main()) add.textContent = 'Add pair to cart · ' + offerMoney(main().price + partner.selected.price - (honest ? discount.amount : 0));
      }
      if (partner && partner.selected && honest) {
        save.textContent = 'Bundle & save ' + offerMoney(discount.amount).replace('.00', '');
        if (save.parentNode !== footer) footer.insertBefore(save, add);
      } else save.remove();
      const alert = element('p', 'kp-pick__pair-error', error);
      // Only a real message is an alert: the add error above the button is the sheet's live alert (A2-2).
      if (error) alert.setAttribute('role', 'alert');
      alert.setAttribute('data-kp-pick-error', '');
      section.append(alert);
      if (focusKey) {
        const target = focusKey === 'change' ? section.querySelector('[data-kp-pick-pair-change]')
          : [...section.querySelectorAll('[data-kp-pick-pair-option]')].find((node) =>
            node.getAttribute('data-kp-pick-pair-option') === focusKey);
        if (target && !target.disabled) target.focus({ preventScroll: true });
      }
    }

    function changeFlavor(entry) {
      let selected = entry.selected;
      const scroll = choices.scrollTop;
      const stepHeader = element('div', 'kp-pick__header kp-pick__header--back');
      const title = element('h2', 'kp-pick__title', entry.label);
      title.id = 'kp-pick-title';
      const prompt = element('p', 'kp-pick__prompt', 'Choose a flavor');
      prompt.id = 'kp-pick-prompt';
      const back = button('kp-pick__back', '←');
      back.setAttribute('data-kp-pick-back', '');
      back.setAttribute('aria-label', 'Back');
      const close = button('kp-pick__close', '×');
      close.setAttribute('data-kp-pick-close', '');
      close.setAttribute('aria-label', 'Close');
      close.addEventListener('click', dismiss);
      const restore = () => {
        update();
        dialog.replaceChildren(header, choices, footer);
        choices.scrollTop = scroll;
        const change = section.querySelector('[data-kp-pick-pair-change]');
        if (change) change.focus({ preventScroll: true });
      };
      back.addEventListener('click', restore);
      stepHeader.append(title, prompt, back, close);
      const body = element('div', 'kp-pick__choices');
      const tiles = element('div', 'kp-pick__tiles');
      entry.product.variants.forEach((variant) => {
        const tile = button('kp-pick__tile');
        tile.setAttribute('data-kp-pick-variant', String(variant.id));
        tile.setAttribute('aria-pressed', String(variant === selected));
        tile.setAttribute('aria-disabled', String(!variant.available));
        tile.disabled = !variant.available;
        const name = offerFlavor(entry.product, variant);
        const source = variant.featured_image || entry.product.featured_image;
        if (source) {
          const img = element('img');
          const url = new URL(typeof source === 'string' ? source : source.src, location.href);
          url.searchParams.set('width', '200');
          img.src = url.href;
          img.alt = name;
          img.width = 200;
          img.height = 200;
          tile.append(img);
        }
        tile.append(element('span', '', name));
        if (!variant.available) tile.append(element('span', 'kp-pick__sold', 'Sold out'));
        tile.addEventListener('click', () => {
          selected = variant;
          [...tiles.children].forEach((node) => node.setAttribute('aria-pressed', String(node === tile)));
        });
        tiles.append(tile);
      });
      body.append(tiles);
      const stepFooter = element('div', 'kp-pick__footer');
      const use = button('kp-pick__add', 'Use this flavor');
      use.setAttribute('data-kp-pick-add', '');
      use.addEventListener('click', () => { entry.selected = selected; entry.explicit = true; restore(); });
      stepFooter.append(use);
      dialog.replaceChildren(stepHeader, body, stepFooter);
      back.focus({ preventScroll: true });
    }

    function remove() { removed = true; partner = null; section.remove(); save.remove(); }
    render();
    choices.append(section);
    offerTrack('kp_pair_picker_view', mode);
    requests.forEach((request, index) => {
      const entry = partners[index];
      request.then((data) => {
        entry.product = data;
        match(entry);
        if (!entry.selected) entry.failed = true;
      }).catch(() => { entry.failed = true; }).finally(() => { if (!removed) update(); });
    });
    return { mode: mode, update: render, remove: remove, partner: () => partner && partner.selected,
      error: (message) => { error = message; } };
  }

  window.kpPick.choose = function (data, options = {}) {
    return new Promise((resolve) => {
      try {
        openPicker(data, null, document.activeElement, {
          selectedId: options.selectedId, title: options.title, subtitle: options.subtitle, resolve: resolve
        });
      } catch (error) {
        dismiss();
        resolve(null);
      }
    });
  };

  // The product is found by the nearest /products/ link. Only trust it when the form's own variant belongs to it,
  // so a form that happens to sit near another product's link is never handed that product's picker.
  function owns(data, form) {
    const input = form.querySelector('input[name="id"]');
    return !!input && data.variants.some((v) => String(v.id) === String(input.value));
  }

  function decide(data, form, submitter) {
    if (owns(data, form) && data.variants.filter((v) => v.available).length >= 2) openPicker(data, form, submitter);
    else resubmit(form, submitter);
  }

  let submitted;
  let submissionNumber = 0;
  let offerDialog;
  let offer;
  const dismissedOffers = new Set();

  function recordSubmit(form) {
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
    const input = form.querySelector('input[name="id"]');
    const skipOffer = skipOffers.has(form);
    skipOffers.delete(form);
    if (input && input.value) submitted = { variantId: input.value, t: Date.now(), number: ++submissionNumber, skipOffer: skipOffer };
  }

  function offerFlavor(data, variant) {
    if (variant.title && variant.title !== 'Default Title') {
      return variant.title.replace(/ – 1 1\/4| - 1 1\/4| - King Size/g, '').trim();
    }
    const title = data.title.replace(/\([^)]*\)/g, '').trim();
    return title.split(/ [–-] /).map((part) => part.trim()).filter((part) => part && !/\d/.test(part)).pop() || title;
  }

  function offerWords(value) {
    return value.toLowerCase().replace(/[-,.]/g, ' ').split(/\s+/).filter(Boolean);
  }

  function offerMatch(data, name) {
    const viewed = offerWords(name);
    const ignored = ['natural', 'variety', 'default'];
    return data.variants.find((variant) => {
      if (!variant.available) return false;
      const candidate = offerWords(offerFlavor(data, variant));
      return (!ignored.includes(candidate[0]) && viewed.includes(candidate[0])) ||
        (!ignored.includes(viewed[0]) && candidate.includes(viewed[0]));
    });
  }

  function offerMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function offerTrack(event, mode) {
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: event, kp_pair: mode });
      }
    } catch (error) { /* Analytics must not interrupt shopping. */ }
  }

  function offerDismissed(mode) {
    try { if (sessionStorage.getItem('kp-pair-offer-dismissed-' + mode)) return true; }
    catch (error) { /* The in-memory flag also works without storage. */ }
    return dismissedOffers.has(mode);
  }

  function closeOffer(dismissed) {
    if (!offer) return;
    if (dismissed) {
      dismissedOffers.add(offer.mode);
      try { sessionStorage.setItem('kp-pair-offer-dismissed-' + offer.mode, '1'); }
      catch (error) { /* Keep the in-memory flag. */ }
      offerTrack('kp_pair_offer_dismiss', offer.mode);
    }
    offer = null;
    if (offerDialog.open) offerDialog.close();
    const control = document.querySelector('cart-drawer.active .drawer__close');
    if (control) control.focus({ preventScroll: true });
  }

  function mountOffer() {
    if (offerDialog) return;
    const style = element('style');
    style.textContent = `
      .kp-offer { inset: auto 0 0; margin: 0; width: 100%; max-width: 100%; max-height: 62dvh;
        padding: 0; border: 0; border-radius: 3px; background: #FFFFFF; color: #0B0C0E;
        font-family: "Lato","Helvetica Neue",Arial,sans-serif; font-size: 14px; line-height: 1.4;
        overflow: hidden; box-sizing: border-box; }
      .kp-offer[open] { display: flex; flex-direction: column; }
      .kp-offer::backdrop { background: rgba(11,12,14,.6); }
      .kp-offer *, .kp-offer *::before, .kp-offer *::after { box-sizing: border-box; }
      .kp-offer button { appearance: none; min-width: 44px; min-height: 44px; margin: 0; padding: 8px;
        border: 1px solid #BEAE82; border-radius: 3px; background: #FFFFFF; color: #0B0C0E;
        font: inherit; letter-spacing: normal; text-transform: none; box-shadow: none; cursor: pointer; }
      .kp-offer button:focus-visible { outline: 2px solid #0B0C0E; outline-offset: 2px; }
      .kp-offer button:disabled { background: #F1F1F1; color: #5C5C5C; cursor: not-allowed; opacity: 1; }
      .kp-offer .kp-offer__body { min-height: 0; overflow-y: auto; overflow-x: hidden;
        overscroll-behavior: contain; padding: 16px; }
      .kp-offer .kp-offer__header { position: relative; padding-right: 44px; min-height: 44px; }
      .kp-offer .kp-offer__title { margin: 0; color: #0B0C0E; font: inherit; font-size: 20px;
        font-weight: 900; overflow-wrap: anywhere; }
      .kp-offer .kp-offer__close { position: absolute; top: -8px; right: -8px; width: 44px; height: 44px;
        border: 0; padding: 0; font-size: 26px; }
      .kp-offer .kp-offer__subline { margin: 4px 0 12px; color: #4A4A4A; }
      .kp-offer .kp-offer__options { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
      .kp-offer .kp-offer__option { border: 2px solid #BEAE82; text-align: left; overflow-wrap: anywhere; }
      .kp-offer .kp-offer__option[aria-pressed="true"] { border-color: #0B0C0E; background: #F5EBD2; }
      .kp-offer .kp-offer__option span { display: block; font-weight: 700; }
      .kp-offer .kp-offer__selected { display: grid; grid-template-columns: 48px minmax(0, 1fr) auto;
        align-items: center; gap: 8px; margin-top: 12px; overflow-wrap: anywhere; }
      .kp-offer .kp-offer__selected img { width: 48px; height: 48px; object-fit: contain; }
      .kp-offer .kp-offer__footer { flex: 0 0 auto; display: grid; gap: 8px; padding: 12px 16px;
        padding-bottom: calc(12px + env(safe-area-inset-bottom)); border-top: 1px solid #ECECEC; }
      .kp-offer .kp-offer__add { background: #E1C78F; font-weight: 700; }
      .kp-offer .kp-offer__error { margin: 8px 0 0; color: #4A4A4A; overflow-wrap: anywhere; }
      .kp-offer .kp-offer__error:empty { margin: 0; }
      @media (min-width: 750px) {
        .kp-offer { inset: 0; margin: auto; width: calc(100% - 48px); max-width: 520px; max-height: 86dvh; }
      }
      @media (prefers-reduced-motion: no-preference) {
        .kp-offer[open] { animation: kp-offer-enter 240ms ease-out; }
        @keyframes kp-offer-enter { from { opacity: 0; transform: translateY(18px); }
          to { opacity: 1; transform: translateY(0); } }
      }
    `;
    document.head.append(style);
    offerDialog = element('dialog', 'kp-offer');
    offerDialog.setAttribute('data-kp-offer', '');
    offerDialog.setAttribute('aria-labelledby', 'kp-offer-title');
    offerDialog.setAttribute('aria-describedby', 'kp-offer-subline');
    offerDialog.addEventListener('cancel', (event) => { event.preventDefault(); closeOffer(true); });
    offerDialog.addEventListener('click', (event) => {
      if (event.target !== offerDialog) return;
      const rect = offerDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) closeOffer(true);
    });
    document.body.append(offerDialog);
  }

  function renderOffer() {
    const state = offer;
    const partner = state.partner;
    const selected = partner.selected;
    const qualifies = state.mode === 'papers' ? state.tipsSubtotal >= state.discount.minTips
      : state.tipsSubtotal + selected.price >= state.discount.minTips;
    const discount = qualifies ? state.discount.amount : 0;
    const body = element('div', 'kp-offer__body');
    const header = element('div', 'kp-offer__header');
    const title = element('h2', 'kp-offer__title', '✓ ' + state.flavor + ' ' + (state.mode === 'papers' ? 'tips' : 'papers') + ' added');
    title.id = 'kp-offer-title';
    const close = button('kp-offer__close', '×');
    close.setAttribute('aria-label', 'Close');
    close.addEventListener('click', () => closeOffer(true));
    header.append(title, close);
    let copy = state.mode === 'papers' ? 'Pair them with hemp papers.' : 'Add flavor tips.';
    if (qualifies) copy += state.mode === 'papers' ? ' Save $1.'
      : ' Save $1 on your papers. One booklet: ' + offerMoney(state.paperPrice) + ' → ' + offerMoney(state.paperPrice - discount) + '.';
    const subline = element('p', 'kp-offer__subline', copy);
    subline.id = 'kp-offer-subline';
    const options = element('div', 'kp-offer__options');
    options.setAttribute('role', 'group');
    options.setAttribute('aria-label', 'Pair with');
    state.partners.forEach((entry) => {
      const option = button('kp-offer__option');
      option.setAttribute('data-kp-offer-option', entry.product.handle);
      option.setAttribute('aria-pressed', String(entry === partner));
      option.disabled = state.busy;
      option.append(element('span', '', entry.label));
      if (discount && state.mode === 'papers') {
        option.append(element('s', '', offerMoney(entry.selected.price)), ' ' + offerMoney(entry.selected.price - discount));
      } else option.append(offerMoney(entry.selected.price));
      option.addEventListener('click', () => { state.partner = entry; renderOffer(); });
      options.append(option);
    });
    const row = element('div', 'kp-offer__selected');
    row.setAttribute('data-kp-offer-variant', String(selected.id));
    const img = element('img');
    const source = selected.featured_image || partner.product.featured_image;
    if (source) {
      const url = new URL(typeof source === 'string' ? source : source.src, location.href);
      url.searchParams.set('width', '112');
      img.src = url.href;
    }
    img.width = 48;
    img.height = 48;
    img.alt = offerFlavor(partner.product, selected);
    const change = button('', 'Change flavor');
    change.disabled = state.busy;
    change.addEventListener('click', async () => {
      offerDialog.close();
      const id = await window.kpPick.choose(partner.product, {
        selectedId: selected.id, title: partner.label, subtitle: 'Choose a flavor'
      });
      if (offer !== state) return;
      const variant = partner.product.variants.find((item) => item.available && String(item.id) === String(id));
      if (variant) partner.selected = variant;
      renderOffer();
      offerDialog.showModal();
    });
    row.append(img, element('span', '', img.alt), change);
    const alert = element('p', 'kp-offer__error', state.error || '');
    alert.setAttribute('role', 'alert');
    body.append(header, subline, options, row, alert);
    const footer = element('div', 'kp-offer__footer');
    const add = button('kp-offer__add', 'Add ' + state.mode + ' · ' + offerMoney(selected.price - (state.mode === 'papers' ? discount : 0)));
    add.setAttribute('data-kp-offer-add', '');
    add.setAttribute('aria-busy', String(state.busy));
    add.disabled = state.busy;
    add.addEventListener('click', addOffer);
    const dismissButton = button('', 'No thanks');
    dismissButton.setAttribute('data-kp-offer-dismiss', '');
    dismissButton.addEventListener('click', () => closeOffer(true));
    footer.append(add, dismissButton);
    offerDialog.replaceChildren(body, footer);
  }

  async function addOffer() {
    if (!offer || offer.busy) return;
    const state = offer;
    state.busy = true;
    state.error = '';
    renderOffer();
    let json;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: state.partner.selected.id, quantity: 1, properties: { _kp_pair: 'offer' } }],
          sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname
        })
      });
      json = JSON.parse(await response.text());
      if (!response.ok || json.status) throw new Error(json.description || "Couldn't add the item. Try again.");
    } catch (error) {
      state.error = json && json.description || "Couldn't add the item. Try again.";
      state.busy = false;
      if (offer === state) renderOffer();
      return;
    }
    try {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.renderContentsWithoutOpen(json);
    } catch (error) { /* The item is already added; never send it twice to refresh the drawer. */ }
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kp-pair-offer', cartData: json });
      }
    } catch (error) { /* The item is already in the cart. */ }
    offerTrack('kp_pair_offer_add', state.mode);
    if (offer === state) closeOffer(false);
  }

  async function inspectOffer(record, drawer) {
    try {
      const configNode = document.getElementById('kp-pair-config');
      if (!configNode) return;
      const config = JSON.parse(configNode.textContent);
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      const line = cart.items.find((item) => String(item.variant_id) === record.variantId);
      if (!line) return;
      const has = (handles) => cart.items.some((item) => item.quantity > 0 && handles.includes(item.handle));
      let mode;
      if (config.tips.includes(line.handle) && !has(config.hasPapers.concat(config.papers))) mode = 'papers';
      if (config.papers.includes(line.handle) && !has(config.tips) &&
          !has(config.hasPapers.filter((handle) => !config.papers.includes(handle)))) mode = 'tips';
      if (!mode || offerDismissed(mode)) return;
      const name = offerFlavor({ title: line.product_title }, { title: line.variant_title });
      const partners = (await Promise.all((mode === 'papers' ? config.paperPartners : config.tipPartners).map(async (entry) => {
        try {
          const data = await product(entry.handle).promise;
          const matched = offerMatch(data, name);
          const selected = matched || data.variants.find((variant) => variant.available &&
            offerWords(offerFlavor(data, variant)).includes(mode === 'papers' ? 'natural' : 'variety')) ||
            data.variants.find((variant) => variant.available);
          return selected ? { label: entry.label, product: data, matched: matched, selected: selected } : null;
        } catch (error) { return null; }
      }))).filter(Boolean);
      if (!partners.length || record.number !== submissionNumber || Date.now() - record.t > 8000 ||
          !drawer.isConnected || !drawer.classList.contains('active') || offer || (dialog && dialog.open)) return;
      mountOffer();
      offer = {
        mode: mode, flavor: name, partners: partners, partner: partners.find((entry) => entry.matched) || partners[0],
        discount: config.discount, busy: false, paperPrice: line.original_price || line.price,
        tipsSubtotal: cart.items.filter((item) => config.tips.includes(item.handle)).reduce((sum, item) =>
          sum + (item.final_line_price == null ? item.price * item.quantity : item.final_line_price), 0)
      };
      renderOffer();
      offerDialog.showModal();
      offerTrack('kp_pair_offer_view', mode);
    } catch (error) { /* An optional offer must never interfere with the completed add. */ }
  }

  // Consume each recorded form submit once, only after the theme opens its drawer.
  new MutationObserver((changes) => {
    if (!submitted || offer) return;
    const opened = changes.find((change) => change.type === 'attributes' && change.target.matches('cart-drawer.active') &&
      !(change.oldValue || '').split(/\s+/).includes('active'));
    if (!opened) return;
    const record = submitted;
    submitted = null;
    if (!record.skipOffer && Date.now() - record.t <= 8000) inspectOffer(record, opened.target);
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });

  window.addEventListener('submit', (event) => {
    const form = event.target;
    let stopped = false;
    try {
      if (approved.has(form)) { approved.delete(form); recordSubmit(form); return; }
      const handle = candidate(form);
      if (!handle) { recordSubmit(form); return; }
      const entry = product(handle);
      if (entry.data && (!owns(entry.data, form) || entry.data.variants.filter((v) => v.available).length < 2)) { recordSubmit(form); return; }
      event.preventDefault();
      stopped = true;
      event.stopPropagation();
      if (pending.has(form) || (active && active.form === form)) return;
      const submitter = event.submitter || form.querySelector('button[type="submit"], button:not([type]), input[type="submit"]');
      if (entry.data) openPicker(entry.data, form, submitter);
      else {
        pending.add(form);
        entry.promise.then((data) => decide(data, form, submitter)).catch(() => {
          dismiss();
          resubmit(form, submitter);
        }).finally(() => pending.delete(form));
      }
    } catch (error) {
      if (stopped) {
        dismiss();
        resubmit(form, event.submitter);
      }
    }
  }, true);

  // The grid already took this quick-view add; make Dawn skip its duplicate request.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!event.defaultPrevented || !(form instanceof HTMLFormElement) ||
        !form.closest('quick-add-modal')) return;
    form.querySelectorAll('[type="submit"], button[name="add"]').forEach((submitter) => {
      const previous = submitter.getAttribute('aria-disabled');
      if (previous === 'true') return;
      submitter.setAttribute('aria-disabled', 'true');
      setTimeout(() => {
        if (previous === null) submitter.removeAttribute('aria-disabled');
        else submitter.setAttribute('aria-disabled', previous);
      }, 0);
    });
  }, true);

  function prefetch(event) {
    try {
      if (!(event.target instanceof Element)) return;
      const submitter = event.target.closest('button, input[type="submit"], input[type="image"]');
      if (!submitter || !['submit', 'image'].includes(submitter.type)) return;
      const handle = candidate(submitter.form);
      if (handle) product(handle).promise.catch(() => {});
    } catch (error) { /* Prefetch must never interfere with the original control. */ }
  }
  ['pointerdown', 'mouseover', 'focusin'].forEach((type) => window.addEventListener(type, prefetch, true));
})();
